export default "__VITE_ASSET__BbDEBAwS__"